import React from 'react';
import { __ } from '@wordpress/i18n'; 

const getIllustrationUrl = () => {
    if (typeof window.thhaAdminSettings !== 'undefined' && window.thhaAdminSettings.assets_url) {
        return window.thhaAdminSettings.assets_url + 'img/feat-req.png';
    }
    return 'none'; // Fallback
};

const FeatureRequestWidget = () => {
  return (
    <div className='feature-request-container'>
      <div className='feature-request-content'>
        <h2 className='feature-request-title'>{__('What\'s Stacking You?', 'huge-addons-for-elementor')}</h2>
        <p className='feature-request-description' style={{ marginBottom: '50px' }}>
          {__('We are always here to help you. If you have any feature request, please let us know', 'huge-addons-for-elementor')}
        </p>
        <a 
          href="#"
          className='feature-request-btn'
          onClick={(e) => {
            // e.preventDefault(); 
            console.log('Request Feature button clicked!');
          }}
        >
          {__('Request Your Features', 'huge-addons-for-elementor')}
        </a>
      </div>
      
      <div 
        className='feature-request-image'
        style={{ backgroundImage: `url(${getIllustrationUrl()})` }}
      >
      </div>
    </div>
  );
};

export default FeatureRequestWidget;